import swiper from 'swiper';


/*-------------------------------------------------------------
インタビュースライド
---------------------------------------------------------------*/
const breakPoint = 768;
let mySwiper;
let mySwiperBool;
let interviewNum = $('.p-archive-interview-list li').length;



/*--------------------------------
ロード時
---------------------------------*/
window.addEventListener('load',()=>{
	//pcの時
	if( breakPoint < window.innerWidth){
		if(interviewNum > 3){
			$('.recruit-single-another__list__wrap').addClass('js-slide-on');
			createSwiper();
			mySwiperBool = true;
		} else {
			$('.recruit-single-another__list__wrap').removeClass('js-slide-on');
			mySwiperBool = false;
		}
	} else {//spの時
		if(interviewNum > 1){
			$('.recruit-single-another__list__wrap').addClass('js-slide-on');
			createSwiper();
			mySwiperBool = true;
		} else {
			$('.recruit-single-another__list__wrap').removeClass('js-slide-on');
			mySwiperBool = false;
		}
	}

},false);

/*--------------------------------
リサイズ時
---------------------------------*/
window.addEventListener('resize',()=>{
  if(mySwiper !== undefined){
    mySwiper.destroy(false,true);
    mySwiperBool = false;
    //pcの時
    if( breakPoint < window.innerWidth){
      if(interviewNum > 3){
        $('.recruit-single-another__list__wrap').addClass('js-slide-on');
        createSwiper();
        mySwiperBool = true;
      } else {
        $('.recruit-single-another__list__wrap').removeClass('js-slide-on');
        mySwiperBool = false;
      }
    } else {//spの時
      if(interviewNum > 1){
        $('.recruit-single-another__list__wrap').addClass('js-slide-on');
        createSwiper();
        mySwiperBool = true;
      } else {
        $('.recruit-single-another__list__wrap').removeClass('js-slide-on');
        mySwiperBool = false;
      }
    }
  }

},false);


const createSwiper = () =>{
  mySwiper = new swiper ('#interviewSlide', {
      slidesPerView: 1,
			speed: 2000,
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
      },
      slidesPerView: "auto",
      loop: true,
      onSlideChangeEnd : (s) => {s.fixLoop();},
      spaceBetween: 48,
      //loopedSlides: 4,
      //centeredSlides : true,
      disableOnInteraction: true,
      slideToClickedSlide: true,
      pagination: {
        el: '.swiper-pagination',
        clickable: true 
      },
      breakpoints: {
        768: {
          //slidesPerView: 1,
          centeredSlides : true,
          spaceBetween: 20,
        }
      }
  });
}
